<template>
	<div style="width: 100%;margin-top: 30px;">
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
		  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
		  <el-breadcrumb-item>分销商信息</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form style="margin-top: 2.5rem" label-width="340px" :model="distributorParam" ref="distributorForm">
		  <el-form-item label="分销商名称:" prop="distributorName">
			{{distributorParam.distributorName}}
		  </el-form-item>
		  <el-form-item label="公司全名:" prop="companyName">
			{{distributorParam.companyName}}
		  </el-form-item>
		  <el-form-item label="联系人:" prop="linkman">
			{{distributorParam.linkman}}
		  </el-form-item>
		  <el-form-item label="联系电话:" prop="phone">
			{{distributorParam.phone}}
		  </el-form-item>
		  <el-form-item label="押金:" prop="antecedentMoney">
			{{distributorParam.antecedentMoney}}
		  </el-form-item>
		  <el-form-item label="合同:" prop="contractUrl">
			<el-image :src="distributorParam.contractUrl"></el-image>
		  </el-form-item>
		  <el-form-item label="营业执照:" prop="businessLicense">
			<el-image :src="distributorParam.businessLicense"></el-image>
		  </el-form-item>
		  <el-form-item label="开户行:" prop="bankAddress">
				{{distributorParam.bankAddress}}
		  </el-form-item>
		  
		  <el-form-item label="银行账号:" prop="bankCardNum">
				{{distributorParam.bankCardNum}}
		  </el-form-item>
		  <el-form-item label="社会统一信用代码:" prop="creditCode">
				{{distributorParam.creditCode}}
		  </el-form-item>
		  <el-form-item label="备注:" prop="note">
				{{distributorParam.note}}
		  </el-form-item>
		</el-form>
		<div slot="footer" style="align-items: center;" class="dialog-footer">
		  <el-button size="small" type="primary" class="title" @click="goback()">返回</el-button>
		</div>
	</div>
</template>

<script>
	
import {uploadSso} from "../../api/common.js"
import {saveDistributorApi,searchDetailApi} from "../../api/distributor/distributorApi.js"
	
export default {
	data() {
		return {
			uploadImgUrl: "http://saasadmin.joybenefits.cn:18101/common/upload",
			distributorParam: {
				distributorName: '',
				companyName: '',
				linkman: '',
				phone: '',
				contractUrl: '',
				businessLicense: '',
				bankAddress: '',
				bankCard: '',
				creditCode: '',
				note: '',
				contractUrl:'',
				businessLicense:''
			},
			contractFileList: []
		}
	},
	methods: {
		goback(){
			this.$router.back(-1)
		},
		getData(){
			let searchParam = {
				id : this.$route.params.id
			}
			searchDetailApi(searchParam).then(ret=>{
				if(ret.data.code == '000000'){
					if(ret.data.data["distributorName"]){
						this.distributorParam.distributorName = ret.data.data.distributorName;
					}
					if(ret.data.data["companyName"]){
						this.distributorParam.companyName = ret.data.data.companyName;
					}
					if(ret.data.data["linkman"]){
						this.distributorParam.linkman = ret.data.data.linkman;
					}
					if(ret.data.data["phone"]){
						this.distributorParam.phone = ret.data.data.phone;
					}
					if(ret.data.data["antecedentMoney"]){
						this.distributorParam.antecedentMoney = ret.data.data.antecedentMoney;
					}
					if(ret.data.data["bankAddress"]){
						this.distributorParam.bankAddress = ret.data.data.bankAddress;
					}
					if(ret.data.data["bankCard"]){
						this.distributorParam.bankCard = ret.data.data.bankCard;
					}
					if(ret.data.data["bankCard"]){
						this.distributorParam.bankCard = ret.data.data.bankCard;
					}
					if(ret.data.data["creditCode"]){
						this.distributorParam.creditCode = ret.data.data.creditCode;
					}
					if(ret.data.data["note"]){
						this.distributorParam.note = ret.data.data.note;
					}
					if(ret.data.data["contractUrl"]){
						this.distributorParam.contractUrl = ret.data.data.contractUrl;
					}
					if(ret.data.data["businessLicense"]){
						this.distributorParam.businessLicense = ret.data.data.businessLicense;
					}
				}
			})
		}
	},
	created() {
	  this.getData()
	},
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/distributor/distributorDetail.vue